const FLAG_KEYS = new Set([
	'showsvvsv',
	'showsvandvsv',
	'showsvvsvinreports',
	'displaysvvsv',
	'showsupervisorsinreports',
	'displaysupervisorsinreports',
	'showsvinreports',
	'svvsvinreports',
	'showsupervisors',
	'displaysv',
	'showsv',
	'svvsv',
]);

const HIDE_KEYS = new Set([
	'hidesvvsv',
	'hidesupervisors',
	'hidesvandvsv',
	'hidesvinreports',
]);

const normalizeKey = (key: string): string =>
	key.replace(/[^a-z0-9]/gi, '').toLowerCase();

const isExplicitFalse = (value: unknown): boolean =>
	value === false ||
	value === 0 ||
	value === '0' ||
	value === 'false' ||
	value === 'FALSE' ||
	value === 'no';

const isExplicitTrue = (value: unknown): boolean =>
	value === true ||
	value === 1 ||
	value === '1' ||
	value === 'true' ||
	value === 'TRUE' ||
	value === 'yes';

const readFlagFromObject = (
	source: any,
	depth = 0
): boolean | null => {
	if (!source || typeof source !== 'object' || depth > 3) {
		return null;
	}

	for (const [key, value] of Object.entries(source)) {
		if (value === undefined || value === null) {
			continue;
		}
		const normalized = normalizeKey(key);
		if (FLAG_KEYS.has(normalized)) {
			if (isExplicitFalse(value)) {
				return false;
			}
			if (isExplicitTrue(value)) {
				return true;
			}
			return Boolean(value);
		}
		if (HIDE_KEYS.has(normalized)) {
			if (isExplicitTrue(value)) {
				return false;
			}
			if (isExplicitFalse(value)) {
				return true;
			}
		}
	}

	const nested = [
		source.contract,
		source.settings,
		source.contract?.settings,
		source.flags,
		source.data,
		source.info,
	];
	for (const item of nested) {
		const value = readFlagFromObject(item, depth + 1);
		if (value !== null) {
			return value;
		}
	}

	return null;
};

/** Флаг контракта: показывать СВ/ВСВ сотрудникам и клиентам. */
export const shouldShowSupervisorsInReports = (
	...sources: Array<any>
): boolean => {
	for (const source of sources) {
		const value = readFlagFromObject(source);
		if (value !== null) {
			return value;
		}
	}
	return true;
};

/** Колонки СВ/ВСВ в списке: скрыть, если у всех отчётов на странице флаг выключен. */
export const shouldShowSupervisorsColumn = (reports?: any[]): boolean => {
	if (!reports?.length) {
		return true;
	}
	return reports.some((report) => shouldShowSupervisorsInReports(report));
};
